'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type SparkleProps = IconProps<keyof typeof animations>;
const animations = {
  default: {
    group: {
      initial: {
        scale: 1
      },
      animate: {
        scale: [1, 0.9, 1.2, 1],
        transition: {
          duration: 0.6,
          ease: 'easeInOut'
        }
      }
    },
    path: {}
  } satisfies Record<string, Variants>,
  fill: {
    group: {
      initial: {
        scale: 1
      },
      animate: {
        scale: [1, 0.9, 1.2, 1],
        transition: {
          duration: 0.6,
          ease: 'easeInOut'
        }
      }
    },
    path: {
      initial: {
        fill: 'currentColor',
        fillOpacity: 0
      },
      animate: {
        fillOpacity: 1,
        transition: {
          delay: 0.2
        }
      }
    }
  } satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(11);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  if ($[4] !== controls) {
    t2 = <motion.path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" variants={variants.path} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== controls || $[7] !== props || $[8] !== size || $[9] !== t2) {
    t3 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" variants={variants.group} initial="initial" animate={controls} {...props}>{t2}</motion.svg>;
    $[6] = controls;
    $[7] = props;
    $[8] = size;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function Sparkle(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, Sparkle, Sparkle as SparkleIcon, type SparkleProps, type SparkleProps as SparkleIconProps };